
import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown';
import story1 from '../img/story1.png'
import story2 from '../img/story2.png'
import story3 from '../img/story3.png'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
export default function SuccessStories() {

    const stories = [
        {
            img: story1,
            title: "Moving usually stinks but they definitely make it a little easier!",
            des: 'This is the second time using Exquisite Moves! Both experiences have been spectacular. Nicest workers and very careful with our items.',
        },
        {
            img: story2,
            title: "Absolutely recommend to anybody that needs help moving!",
            des: 'This is the second time using Exquisite Moves! Both experiences have been spectacular. Nicest workers and very careful with our items.',
        },
        {
            img: story3,
            title: "Efficient & accommodating also remarkable communication! ",
            des: 'I have made many moves, in-state and interstate. This was the absolutely best experience on every side.',
        },
        {
            img: story1,
            title: "Moving usually stinks but they definitely make it a little easier!",
            des: 'This is the second time using Exquisite Moves! Both experiences have been spectacular. Nicest workers and very careful with our items.',
        },
    ];

    var settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow:2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint:767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding :"15%",
            }
          } 
        ]
      };


    return <>
        <div className="succesStories pt-3 pt-sm-5 pb-5 " >
            <div className="container">
                <div className="topTitle" >
                    <div className="row align-items-center " >
                        <div className="col-md-6 left pe-md-2" >
                            <p className="orange-link text-uppercase">Success stories</p>
                            <h2>When our customers win, we win too.</h2>
                        </div>
                        <div className="col-md-6 right ps-md-5" >
                            <p>See how our customers — from some of the world’s largest companies to the most innovative startups — use Exquisite Moves to reach their Moving & Packaging goals.</p>
                        </div>
                    </div>
                </div>
                <div className="storiesFilter mt-0 mt-sm-4 " >
                    <div className="row" >
                        <div className="col-lg-3 col-sm-4   mt-2 mt-sm-0 " >
                            <DropdownButton id="dropdown-basic-button"
                                title="All Industries">
                                <Dropdown.Item href="#/action-1">All Industries</Dropdown.Item>
                                <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                            </DropdownButton>
                        </div>
                        <div className="col-lg-3 col-sm-4 mt-2 mt-sm-0        " >
                            <DropdownButton id="dropdown-basic-button"
                                title="All Regions">
                                <Dropdown.Item href="#/action-1">All Industries</Dropdown.Item>
                                <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                            </DropdownButton>
                        </div>
                    </div>
                </div>
                <div className=' mt-3 mt-md-4'  >
                <Slider {...settings}>
                  {stories.map((s, i) => {
                        return <>
                            <div key={i} className='item' >
                                <div className='storyBox' >
                                    <div className='stroyImg' >
                                        <img src={s.img} className="img-fluid" alt='image' />
                                    </div>
                                    <div className='stroyContent' >
                                        <h2>{s.title}</h2>
                                        <p>{s.des}</p>
                                        <a href='#' >Read full story <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.5771 13.5774C13.2516 13.9028 13.2516 14.4305 13.5771 14.7559C13.9025 15.0814 14.4302 15.0814 14.7556 14.7559L18.9223 10.5893C19.2477 10.2638 19.2477 9.73618 18.9223 9.41075L14.7556 5.24408C14.4302 4.91864 13.9025 4.91864 13.5771 5.24408C13.2516 5.56951 13.2516 6.09715 13.5771 6.42259L16.3212 9.16667H1.66634C1.2061 9.16667 0.833008 9.53976 0.833008 10C0.833008 10.4602 1.2061 10.8333 1.66634 10.8333H16.3212L13.5771 13.5774Z" fill="#FF9900" />
                                        </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </>
                    })}
                </Slider>
                </div>
            </div>
        </div>
    </>
}